<footer class="footer" role="contentinfo" data-track-group="Footer">
  <div class="footer__user">
    <div [class]="mainContainerClass">
      <div [class]="pageContainerClass" *ngIf="viewModel | async as vm">
        <ng-container *ngIf="vm.isLoggedIn; else notLoggedIn">
          <ng-container *ngIf="vm.hasAdminPermission && vm.hasMinimumItems; else notAdmin">
            <!-- User is logged in and has admin permissions -->
            <ftr-footer-admin></ftr-footer-admin>
          </ng-container>
          <ng-template #notAdmin>
            <!-- User is logged in and any permissions other than admin permissions -->
            <ftr-footer-logged-in></ftr-footer-logged-in>
          </ng-template>
        </ng-container>
        <!-- User is not logged in -->
        <ng-template #notLoggedIn>
          <ftr-footer-logged-out></ftr-footer-logged-out>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="footer__disclaimer">
    <div [class]="mainContainerClass">
      <div [class]="pageContainerClass">
        <ftr-footer-disclaimer></ftr-footer-disclaimer>
      </div>
    </div>
  </div>
</footer>
